import { Button, ButtonDropdown, Dialog, LoadMoreButton, Notification, Spinner } from '@rio-cloud/rio-uikit';
import { useEffect, useState } from 'react';
import { RestrictArea } from '../../../../../../components/restrictArea';
import { Form } from '../form';
import { deleteMatrizSupport, fetchSubjectsSupport } from '../../../../../../api/tas';
import { useIntl } from 'react-intl';
import SubjectForm from '../form/SubjectForm';

export type Field = {
    field: string;
    required: boolean;
}

export interface IResponseSubjectData {
    code: string;
    createdAt: string;
    disabled: boolean;
    fields: Field[]
    id: number;
    name: string;
    updateAt: string;
}

const SubjectListContent = () => {
    const [showForm, setShowForm] = useState(false);
    const [loading, setLoading] = useState(true);
    const [userHasAccess, setUserHasAccess] = useState(true);
    const [pageSize, setPageSize] = useState(20);
    const [totalElements, setTotalElements] = useState(0);
    const [data, setData] = useState<IResponseSubjectData[]>([]);
    const [edit, setEdit] = useState<null | IResponseSubjectData>(null)
    const intl = useIntl();

    const fetchList = async () => {
        try {
            setLoading(true);
            const params = {
                pageSize,
            };

            const response = await fetchSubjectsSupport(params);
            if (!response.content) {
                throw new Error('NO_CONTENT')
            }

            setData(response.content)
            setLoading(false);
            setTotalElements(response.totalElements);
            setPageSize(response.numberOfElements);
        } catch (error) {
            setData([]);
        } finally {
            setLoading(false);
        }
    }

    const handleFormClose = () => {
        setShowForm(false)
    };

    const onLoadMore = () => {
        const nextSize = pageSize + 30;

        setPageSize(nextSize > totalElements ? totalElements : nextSize);
    }

    const handleCloseForm = () => {
        setEdit(null);
        setShowForm(false);
        fetchList();
    }


    if (!userHasAccess) {
        return <RestrictArea showBackButton={false} />;
    }

    useEffect(() => {
        fetchList()
    }, [pageSize])


    return loading ? (
        <div className="flex justify-center items-center h-64">
            <Spinner />
        </div>
    ) : (
        <div className="p-6 max-w-[1000px] mx-auto">
            <div className="flex justify-between items-center mb-6">
                <div>
                    <div className="text-size-h2">Assuntos</div>
                </div>
                <Button
                    bsStyle={Button.PRIMARY}
                    onClick={() => setShowForm(true)}
                    iconName="rioglyph-plus-sign"
                >
                    Criar
                </Button>
            </div>

            <div className="bg-white rounded-lg shadow overflow-hidden">
                <div>
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left font-medium text-gray-500">
                                    {intl.formatMessage({ id: "intl-msg:backoffice-support-table-name" })}
                                </th>
                                <th className="px-6 py-3 text-left font-medium text-gray-500">
                                    {intl.formatMessage({ id: "intl-msg:backoffice-support-table-code" })}
                                </th>
                                <th className="px-6 py-3 text-right font-medium text-gray-500"></th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {data?.map((d) => (
                                <tr key={d.id} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-gray-900">
                                            {d.name}
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-gray-900 text-capitalize">{d?.code}</div>
                                    </td>

                                    <td className="px-6 py-4 whitespace-nowrap text-right font-medium">
                                        <div className="flex justify-end space-x-2">
                                            {d.disabled ? null : (
                                                <ButtonDropdown
                                                    title={<span className='rioglyph rioglyph-option-vertical' />}
                                                    items={[
                                                        {
                                                            value: 'Editar',
                                                            onSelect: () => {
                                                                setEdit(d);
                                                                setShowForm(true);
                                                            }
                                                        },
                                                    ]}
                                                    bsStyle='muted'
                                                    pullRight
                                                    noCaret
                                                    usePortal
                                                />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {data.length === 0 && (
                    <div className="text-center py-12">
                        <div className="text-gray-500">
                            <p className="font-medium mb-2">Sem resultado</p>
                        </div>
                    </div>
                )}
            </div>

            <LoadMoreButton
                loaded={pageSize}
                total={totalElements}
                onLoadMore={onLoadMore}
                loadMoreMessage={intl.formatMessage({ id: "intl-msg:monitoring.loadMore" })}
                noMoreMessage={intl.formatMessage({ id: "intl-msg:monitoring.allLoaded" })}
            />

            {showForm && (
                <Dialog
                    show={showForm}
                    onClose={handleFormClose}
                    showCloseButton={true}
                    title={edit ? 'Criar assunto' : 'Editar assunto'}
                    bsSize={Dialog.SIZE_SM}
                    body={(
                        <SubjectForm onCancel={handleCloseForm} onSuccess={handleCloseForm} data={edit} />
                    )}
                />
            )}
        </div>
    );
};

const SubjectList = (props: any) => {
    return (
        <SubjectListContent {...props} />
    );
};

export default SubjectList;

